import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { AlertEntity } from '@src/entities/Alert/includes/types';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';
import { Table as AbyssTable } from '@uhg-abyss/web/ui/Table';
import { Tooltip } from '@uhg-abyss/web/ui/Tooltip';
import React from 'react';

type TableProps = {
  alert?: AlertEntity;
};

/**
 * Table
 *
 * Displays alert information in a table format, including last updated date and description.
 * The description cell uses a tooltip for full text visibility.
 */
export function Table({ alert }: TableProps) {
  return (
    <ErrorHandler location="src/entities/Alert/ui/components/Modal/components/Table/Table.tsx">
      <AbyssTable.Container style={{ tableLayout: 'fixed', width: '752px' }} title="">
        <AbyssTable.TableHeader>
          <AbyssTable.TableHeaderRow>
            <AbyssTable.Column style={{ width: '25%' }}>Last Updated</AbyssTable.Column>
            <AbyssTable.Column>Description</AbyssTable.Column>
          </AbyssTable.TableHeaderRow>
        </AbyssTable.TableHeader>
        <AbyssTable.TableBody>
          <AbyssTable.Row>
            <AbyssTable.Cell>
              {alert?.lastModifiedDate ? dayjs(alert.lastModifiedDate).format('MM/DD/YYYY, HH:mm:ss') : ''}
            </AbyssTable.Cell>
            <AbyssTable.Cell>
              <Tooltip
                content={
                  <div
                    style={{
                      fontFamily: themeConfiguration?.theme?.fonts?.primary,
                      padding: themeConfiguration?.theme?.space?.sm,
                    }}
                  >
                    {alert?.shortDesc}
                  </div>
                }
              >
                <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {alert?.shortDesc}
                </div>
              </Tooltip>
            </AbyssTable.Cell>
          </AbyssTable.Row>
        </AbyssTable.TableBody>
      </AbyssTable.Container>
    </ErrorHandler>
  );
}
